import { faClockThreeThirtySolid } from '@/lib/fa'
import ActivityItem from '@/modules/drivers/forms/activities/components/ActivityItem'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { TimeField } from '@/ui/form/controls/TimeField'
import React, { useEffect } from 'react'
import { NumberField } from '@/ui/form/controls/NumberField'
import moment from 'moment'
import { useRaportForm } from '@/modules/printouts/context/RaportFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const Time = () => {
  const { t } = useLocalize()
  const { data, setData } = useRaportForm()

  const initialStartDate = moment()
  const initialEndDate = moment().subtract(1, 'month')

  const [hours, setHours] = React.useState<number | null>(
    data.durationHours ?? null,
  )
  const [minutes, setMinutes] = React.useState<number | null>(
    data.durationMinutes ?? null,
  )

  const handleFormatTime = () => {
    if (hours === null && minutes === null) return
    {
      setData({ ...data, activityDurationMinTime: hours * 60 + minutes })
    }
  }

  useEffect(() => {
    handleFormatTime()
  }, [minutes, hours])


  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-flex tw-flex-1 tw-items-start tw-gap-2 tw-font-medium tw-text-content-base">
        <StageHeader
          title={t('printout.duration')}
          textSize="sm"
          icon={faClockThreeThirtySolid}
        />

        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
          <div className="tw-flex tw-flex-col tw-gap-2">
            <ActivityItem
              onClick={() =>
                setData({
                  ...data,
                  activityDurationMinTimeEnabled:
                    !data.activityDurationMinTimeEnabled,
                })
              }
              label={t('printout.activities-lasting-above')}
              checked={data.activityDurationMinTimeEnabled}
            />
            {data.activityDurationMinTimeEnabled && (
              <div className="tw-flex tw-items-center tw-justify-start tw-gap-2 tw-pl-4">
                <NumberField
                  inputSize="sm"
                  placeholder="0"
                  value={hours}
                  setValue={(e) => setHours(e)}
                  min={0}
                  max={23}
                  label="h"
                />
                <NumberField
                  inputSize="sm"
                  placeholder="0"
                  value={minutes}
                  setValue={(e) => setMinutes(e)}
                  min={0}
                  max={59}
                  label="m"
                />
              </div>
            )}
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2">
            <ActivityItem
              onClick={() =>
                setData({
                  ...data,
                  activityBetweenHoursEnabled:
                    !data.activityBetweenHoursEnabled,
                })
              }
              label={t('printout.activities-between-hours')}
              checked={data.activityBetweenHoursEnabled}
            />
            {data.activityBetweenHoursEnabled && (
              <div className="tw-flex tw-items-center tw-justify-start tw-gap-2 tw-pl-4">
                <TimeField
                  inputSize="sm"
                  placeholder="00:00"
                  value={data.activityBetweenHoursStartTime ?? null}
                  setValue={(e) =>
                    setData({ ...data, activityBetweenHoursStartTime: e })
                  }
                />
                <span>-</span>
                <TimeField
                  inputSize="sm"
                  placeholder="00:00"
                  value={data.activityBetweenHoursEndTime ?? null}
                  setValue={(e) =>
                    setData({ ...data, activityBetweenHoursEndTime: e })
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Time
